export default function Consultation() {
  return (
    <div className="min-h-screen py-8">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">AI Consultation</h1>
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-gray-600">Start a new consultation with AI assistance.</p>
        </div>
      </div>
    </div>
  );
}
